import { render, staticRenderFns } from "./BotIndex.vue?vue&type=template&id=44bd891c&"
import script from "./BotIndex.vue?vue&type=script&lang=js&"
export * from "./BotIndex.vue?vue&type=script&lang=js&"
import style0 from "./BotIndex.vue?vue&type=style&index=0&id=44bd891c&prod&lang=less&"
import style1 from "./BotIndex.vue?vue&type=style&index=1&id=44bd891c&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports